import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import FilterState from '../../components/country-select/FilterState';
import CountrySelect from '../../components/country-select/CountrySelect';
import BasicRangeShortcuts from '../../components/date-range-picker/BasicRangeShortcuts';
import HeadTitle from '../../components/HeadTitle';
import HeaderStats from '../../components/verification-request/HeaderStats';
import VerificationTable from '../../components/verification-request/VerificationTable';
import SearchFilter from '../../components/analytics-and-insights/SearchFilter';
import { useSelector } from 'react-redux';
import {
  fetchUserData,
  fetchUsersList,
  fetchVerificationData,
} from '../../api/user';

const statsData = [
  {
    title: 'Total Verification Requests',
    idverification: 'ID Verification',
    selfieverification: 'Selfie Verification',
    idCount: 0, // Dynamic value for ID Verification count
    selfieCount: 0, // Dynamic value for Selfie Verification count
    fixedColor: '#007bff',
  },
  {
    title: 'Approved Requests',
    idverification: 'ID Verification',
    selfieverification: 'Selfie Verification',
    idCount: 0,
    selfieCount: 0,
    fixedColor: '#28a745',
  },
  {
    title: 'Rejected Requests',
    idverification: 'ID Verification',
    selfieverification: 'Selfie Verification',
    idCount: 0,
    selfieCount: 0,
    fixedColor: '#dc3545',
  },
  {
    title: 'Pending Requests',
    idverification: 'ID Verification',
    selfieverification: 'Selfie Verification',
    idCount: 0,
    selfieCount: 0,
    fixedColor: '#ffc107',
  },
];

const VerificationRequest = () => {
  // const { filter } = useSelector((state) => state);
  const [currentPage, setCurrentPage] = useState(1);
  const filter = useSelector((state) => state.filter);
  const searchTermFromStore = useSelector((state) => state.filter.searchTerm);
  const normalizedSearchTermFromStore = searchTermFromStore ?? '';
  const filterWithoutUTM = useMemo(() => {
    const { utm_options, ...rest } = filter;
    setCurrentPage(1)
    return rest;
  }, [JSON.stringify(filter)]);
  const [userData, setUserData] = useState([]);
  const [filteredData, setFilteredData] = useState(userData);
  const [verificationData, setVerificationData] = useState({});
  const [stats, setStats] = useState(statsData);
  const [pageLimit, setPageLimit] = useState(25);
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [totalUsers, setTotalUsers] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState(null);
  const [activeFilter, setActiveFilter] = useState('All');
  // useEffect(() => {
  //   if ((searchTerm ?? '') !== normalizedSearchTermFromStore) {
  //     setSearchTerm(normalizedSearchTermFromStore);
  //     setCurrentPage(1);
  //   }
  // }, [normalizedSearchTermFromStore]);
  const [components] = useState([
    {
      id: 1,
      imageSrc: '/assets/images/admin-panel/verification/verify.svg',
      text: 'Verification ',
      description:
        'Informed about platform updates, upcoming features, policy changes, events, and other important information',
    },
  ]);

  const handleFilterChange = (statusFilter) => {
    if (statusFilter === '') {
      setFilteredData(userData);
    } else {
      setFilteredData(userData.filter((item) => item.status === statusFilter));
    }
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      // prevent calling api on search
      searchTermFromStore==null && await fetchVerificationData(filter, setVerificationData);
      const data = await fetchUsersList({
        filter:{...filter,requestType:"verification"},
        setUserData,
        page: currentPage,
        limit: pageLimit,
        skip: 0,
        verification: true,
        isSelfieVerification: activeFilter === 'Selfie Verification' || false,
        isIdVerification: activeFilter === 'ID Verification' || false,
        // isBot: false,
        searchTerm:filterWithoutUTM?.searchTerm,
      });
      setTotalUsers(data.totalUsersCount);
      setTotalPages(data.totalPages);
    } catch (error) {
      console.error('Error while loading real-time data', error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    fetchData();
  }, [JSON.stringify(filterWithoutUTM), activeFilter, currentPage]);

  // useEffect(() => {
  //   setFilteredData(userData);
  // }, [userData]);

  useEffect(() => {
    if (Object.keys(verificationData).length !== 0) {
      const response = verificationData;

      const updatedStats = statsData.map((stat) => {
        switch (stat.title) {
          case 'Total Verification Requests':
            return {
              ...stat,
              idCount: response.totalRequests[0].idVerification,
              selfieCount: response.totalRequests[0].selfieVerification,
            };
          case 'Approved Requests':
            return {
              ...stat,
              idCount: response.approvedRequests[0].idVerification,
              selfieCount: response.approvedRequests[0].selfieVerification,
            };
          case 'Rejected Requests':
            return {
              ...stat,
              idCount: response.rejectedRequests[0].idVerification,
              selfieCount: response.rejectedRequests[0].selfieVerification,
            };
          case 'Pending Requests':
            return {
              ...stat,
              idCount: response.pendingRequests[0].idVerification,
              selfieCount: response.pendingRequests[0].selfieVerification,
            };
          default:
            return stat;
        }
      });

      setStats(updatedStats);
    }
  }, [verificationData]);

  const handleSearch = () => {
    fetchData()
  }

  return (
    <div>
      {/* Dynamically Render Components */}
      {components.map((component) => (
        <HeadTitle
          key={component.id}
          imageSrc={component.imageSrc}
          text={component.text}
          description={component.description}
        />
      ))}

      <SearchFilter isHideUserManagement={false} isHideSelectCam={false} />

      <HeaderStats
        stats={stats}
        data={userData}
        onFilterChange={handleFilterChange}
      />
      <VerificationTable
        data={userData}
        totalPages={totalPages}
        currentPage={currentPage}
        handlePageChange={handlePageChange}
        itemsPerPage={itemsPerPage}
        loading={loading}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        // handleSearch={handleSearch}
        fetchData={fetchData}
        activeFilter={activeFilter}
        setActiveFilter={setActiveFilter}
      />
    </div>
  );
};

export default VerificationRequest;
